import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "device-mobile-vibration",
  "use": "device-mobile-vibration-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-device-mobile-vibration\" viewBox=\"0 0 24 24\" id=\"device-mobile-vibration\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><g transform=\"rotate(20 12 12)\"><rect width=\"10\" height=\"16\" x=\"7\" y=\"4\" rx=\"1\" /><path d=\"M11 5h2M12 17v.01M3 8v8M21 8v8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol